(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}(g.Calc || (g.Calc = {})).Calc = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],2:[function(require,module,exports){
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],3:[function(require,module,exports){
"use strict";

/* Data: {
    age,
    weight,
    race,
    gender,
    specialNeeds (neutered, pregnant, lactating)
    ?bodyConditionScore (5 - Ideal weight, 6 - Overweight, 7 - Overweight),
    ?numberOfPuppies (1 - 20)
    ?lactationWeek (week 1 - 7)
}
*/
//let outputRange = {min: 0, max: 2000}
//let getWeigthSize = function(weigth) {
//    return weigth < 6 ? 'mini' : (weigth < 11 ? 'small' : (weigth < 26 ? 'medium' : (weigth < 45 ? 'big' : 'giant')));
//}
// RACES
// ----------------------------------------------------------------------------------------------------------
var races = [{
  "name": "Abyssinian",
  "weight": {
    "m": [4, 6],
    "f": [4, 6]
  }
}, {
  "name": "Turkish Angora",
  "weight": {
    "m": [3, 5],
    "f": [3, 5]
  }
}, {
  "name": "Bengal",
  "weight": {
    "m": [4, 6],
    "f": [4, 6]
  }
}, {
  "name": "Bombay",
  "weight": {
    "m": [2.5, 5],
    "f": [2.5, 5]
  }
}, {
  "name": "Norwegian Woods",
  "weight": {
    "m": [5.5, 7.5],
    "f": [4, 5.5]
  }
}, {
  "name": "British Shorthair",
  "weight": {
    "m": [4, 8],
    "f": [3.5, 5.5]
  }
}, {
  "name": "Burmilla",
  "weight": {
    "m": [4, 7],
    "f": [4, 7]
  }
}, {
  "name": "Chartreux",
  "weight": {
    "m": [3, 7.5],
    "f": [3, 7.5]
  }
}, {
  "name": "Cornish Rex",
  "weight": {
    "m": [2.5, 4.5],
    "f": [2.5, 4.5]
  }
}, {
  "name": "Devon Rex",
  "weight": {
    "m": [2.5, 4],
    "f": [2.5, 4]
  }
}, {
  "name": "Exotic Shorthair",
  "weight": {
    "m": [3, 6.5],
    "f": [3, 6.5]
  }
}, {
  "name": "Maine Coon",
  "weight": {
    "m": [6, 9],
    "f": [4, 6]
  }
}, {
  "name": "Oriental Shorthair",
  "weight": {
    "m": [4, 6.5],
    "f": [4, 6.5]
  }
}, {
  "name": "Persian",
  "weight": {
    "m": [4, 6],
    "f": [3, 5.5]
  }
}, {
  "name": "Ragdoll",
  "weight": {
    "m": [4.5, 9],
    "f": [4.5, 9]
  }
}, {
  "name": "Sacred of Burma",
  "weight": {
    "m": [4.5, 8],
    "f": [4.5, 8]
  }
}, {
  "name": "Scottish Fold",
  "weight": {
    "m": [2.5, 6],
    "f": [2.5, 6]
  }
}, {
  "name": "Siamese",
  "weight": {
    "m": [4.5, 7],
    "f": [3.5, 5.5]
  }
}, {
  "name": "Siberian",
  "weight": {
    "m": [4.5, 9],
    "f": [4.5, 9]
  }
}, {
  "name": "Somali",
  "weight": {
    "m": [3.5, 5],
    "f": [3.5, 5]
  }
}, {
  "name": "Sphynx",
  "weight": {
    "m": [4, 5],
    "f": [3, 4]
  }
}, {
  "name": "No Defined Breed (NDB)",
  "weight": {
    "m": [4, 6],
    "f": [4, 6]
  } // }, {
  //     "name": "Outra Raça",
  //     "weight": {
  //         "m": [4, 4],
  //         "f": [4, 4]
  //     }

}]; // RULES
// ----------------------------------------------------------------------------------------------------------

var rules = {};
var rulesTestPriority = ['neutered', 'pregnant', 'lactating', 'puppy', 'senior', 'adult'];
/* Special Needs - Neutered */

rules.neutered = {
  name: 'neutered',
  data: {
    scoreData: {
      5: {
        multiplier: 100,
        exp: 0.67
      },
      6: {
        multiplier: 75,
        exp: 0.67
      }
    }
  },
  requiredFields: ['weight', 'age', 'specialNeeds', 'bodyConditionScore'],
  test: function test(data) {
    return data.specialNeeds === 'neutered' && !rules.puppy.test(data);
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var scoreData = rules.neutered.data.scoreData[data.bodyConditionScore];
    if (!scoreData) throw 'Inform a valid body condition.';
    return Math.pow(data.weight, scoreData.exp) * scoreData.multiplier;
  }
};
/* Special Needs - Pregnant */

rules.pregnant = {
  name: 'pregnant',
  data: {
    multiplier: 140,
    exp: 0.67
  },
  requiredFields: ['weight', 'age', 'specialNeeds'],
  test: function test(data) {
    return data.specialNeeds === 'pregnant' && (rules.adult.test(data) || rules.senior.test(data));
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    return Math.pow(data.weight, rules.pregnant.data.exp) * rules.pregnant.data.multiplier;
  }
};
/* Special Needs - Lactating */

rules.lactating = {
  name: 'lactating',
  data: {
    multiplier: 100,
    exp: 0.67,
    multipliers: {
      lactationWeek: {
        1: 0.9,
        2: 0.9,
        3: 1.2,
        4: 1.2,
        5: 1.1,
        6: 1,
        7: 0.8
      },
      puppiesRange: {
        1: 18,
        2: 60,
        3: 70
      }
    }
  },
  requiredFields: ['weight', 'age', 'specialNeeds', 'lactationWeek', 'numberOfPuppies'],
  test: function test(data) {
    return data.specialNeeds === 'lactating' && data.weight > 0 && data.age > 0 && rules.adult.test(data);
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    if (!(data.lactationWeek > 0) || !rules.lactating.data.multipliers.lactationWeek[data.lactationWeek]) throw 'Inform a valid lactation week.';
    if (!(data.numberOfPuppies > 0)) throw 'Inform a valid number of puppies.';
    var puppiesRange = data.numberOfPuppies < 3 ? 1 : data.numberOfPuppies < 5 ? 2 : 3;
    var puppiesMult = rules.lactating.data.multipliers.puppiesRange[puppiesRange];
    var weekMult = rules.lactating.data.multipliers.lactationWeek[data.lactationWeek];
    var ne = Math.pow(data.weight, rules.lactating.data.exp) * rules.lactating.data.multiplier;
    return ne + puppiesMult * weekMult * data.weight;
  }
};
/* Puppy */

rules.puppy = {
  name: 'puppy',
  data: {
    maxAge: 11,
    multiplier: 100,
    exp: 0.67,
    c1: 6.732,
    c2: 2.718,
    c3: -0.189,
    c4: 0.66
  },
  requiredFields: ['weight', 'actualWeight', 'age'],
  //, 'race', 'gender'],
  test: function test(data) {
    // return data.weight > 0 && data.age > 0 && data.age <= rules.puppy.data.maxAge;
    return data.age > 0 && data.age <= rules.puppy.data.maxAge;
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    if (!(data.actualWeight > 0)) throw 'Inform a valid actual weight.';
    if (parseInt(data.weight) < parseInt(data.actualWeight)) throw 'Actual weight cannot be bigger than adult weight.';
    /*
    let race = races.find(function(r) { return r.name === data.race; });
    if (!data.race || !race) throw 'Inform a valid race.';
    let weightRange = race.weight[(data.gender || '').substr(0, 1).toLowerCase()];
    if (!data.gender || !weightRange) throw 'Inform a valid gender.';
      let adultWeightAvg = (weightRange[0] + weightRange[1]) / 2;
    let weightRatio = data.weight / adultWeightAvg;
    */

    var weightRatio = data.actualWeight / data.weight;
    var puppyData = rules.puppy.data;
    return puppyData.multiplier * Math.pow(data.actualWeight, puppyData.exp) * puppyData.c1 * (Math.pow(puppyData.c2, puppyData.c3 * weightRatio) - puppyData.c4);
  }
};
/* Senior */

rules.senior = {
  name: 'senior',
  data: {
    minAge: 7 * 12,
    scoreData: {
      5: {
        multiplier: 100,
        exp: 0.67
      },
      6: {
        multiplier: 75,
        exp: 0.67
      }
    }
  },
  requiredFields: ['weight', 'age', 'bodyConditionScore'],
  test: function test(data) {
    return data.weight > 0 && data.age > 0 && data.age >= rules.senior.data.minAge;
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var scoreData = rules.senior.data.scoreData[data.bodyConditionScore];
    if (!scoreData) throw 'Inform a valid body condition.';
    return Math.pow(data.weight, scoreData.exp) * scoreData.multiplier;
  }
};
/* Adult */

rules.adult = {
  name: 'adult',
  data: {
    scoreData: {
      5: {
        multiplier: 100,
        exp: 0.67
      },
      6: {
        multiplier: 75,
        exp: 0.67
      }
    }
  },
  requiredFields: ['weight', 'age', 'bodyConditionScore'],
  test: function test(data) {
    return data.weight > 0 && data.age > 0 && !rules.puppy.test(data) && !rules.senior.test(data) && data.age > 0;
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var scoreData = rules.adult.data.scoreData[data.bodyConditionScore];
    if (!scoreData) throw 'Inform a valid body condition.';
    return Math.pow(data.weight, scoreData.exp) * scoreData.multiplier;
  }
}; // DRY FOODS
// ----------------------------------------------------------------------------------------------------------

var dryFoods = [// Neutered
{
  product: 'GUABI NATURAL ADULT CAT NEUTERED',
  image: 'GN_Cereais_Integrais_Gato_Adulto_Castrado_Sabor_Frango_e_Arroz_Integral_7_5kg_FRONTAL.png',
  variations: [{
    id: 183,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Gato_Adulto_Castrado_Sabor_Frango_e_Arroz_Integral_7_5kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/gato-adulto-castrado-frango-e-arroz-integral/'
  }, {
    id: 179,
    product: 'SALMON AND BARLEY',
    image: 'GN_Cereais_Integrais_Gato_Adulto_Castrado_Sabor_Salmao_e_Cevada_7_5kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/gato-adulto-castrado-salmao-e-cevada/'
  }, {
    id: 186,
    product: 'LAMB AND OATS',
    image: 'GN_Cereais_Integrais_Gato_Adulto_Castrado_Sabor_Cordeiro_e_Aveia_7_5kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/gato-adulto-castrado-cordeiro-e-aveia/'
  }],
  em: 3.8,
  type: 'Low Grain',
  test: function test(data) {
    return data.specialNeeds === 'neutered' && rules.adult.test(data);
  }
}, {
  product: 'GUABI NATURAL SENIOR CAT NEUTERED',
  image: 'GN_Cereais_Integrais_Gato_Senior_Castrado_Sabor_Frango_e_Arroz_Integral_7_5kg_FRONTAL.png',
  variations: [{
    id: 407,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Gato_Senior_Castrado_Sabor_Frango_e_Arroz_Integral_7_5kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/gato-senior-castrado-frango-e-arroz-integral/'
  }],
  em: 4.1,
  type: 'Low Grain',
  test: function test(data) {
    return data.specialNeeds === 'neutered' && rules.senior.test(data);
  }
}, // Pregnant
{
  product: 'GUABI NATURAL PUPPY CAT',
  image: 'GN_Cereais_Integrais_Gato_Filhote_Sabor_Frango_e_Arroz_Integral_0_5kg_FRONTAL.png',
  variations: [{
    id: 168,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Gato_Filhote_Sabor_Frango_e_Arroz_Integral_0_5kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/gato-filhote-frango-e-arroz-integral/'
  }],
  em: 4.3,
  type: 'Low Grain',
  message: 'Guabi Natural puppy cat can be offered to pregnant or lactating cats',
  test: function test(data) {
    return data.specialNeeds === 'pregnant';
  }
}, // lactating
{
  product: 'GUABI NATURAL PUPPY CAT',
  image: 'GN_Cereais_Integrais_Gato_Filhote_Sabor_Frango_e_Arroz_Integral_0_5kg_FRONTAL.png',
  variations: [{
    id: 168,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Gato_Filhote_Sabor_Frango_e_Arroz_Integral_0_5kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/gato-filhote-frango-e-arroz-integral/'
  }],
  em: 4.3,
  type: 'Low Grain',
  message: 'Guabi Natural puppy cat can be offered to pregnant or lactating cats',
  test: function test(data) {
    return data.specialNeeds === 'lactating';
  }
}, // Senior
{
  product: 'GUABI NATURAL SENIOR CAT NEUTERED',
  image: 'GN_Cereais_Integrais_Gato_Senior_Castrado_Sabor_Frango_e_Arroz_Integral_7_5kg_FRONTAL.png',
  variations: [{
    id: 407,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Gato_Senior_Castrado_Sabor_Frango_e_Arroz_Integral_7_5kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/gato-senior-castrado-frango-e-arroz-integral/'
  }],
  em: 4.1,
  type: 'Low Grain',
  message: 'Guabi Natural senior cat can also be offered to non-neutered cats or according to the veterinarian\'s guidance',
  test: function test(data) {
    return rules.senior.test(data);
  }
}, // Puppy
{
  product: 'GUABI NATURAL PUPPY CAT',
  image: 'GN_Cereais_Integrais_Gato_Filhote_Sabor_Frango_e_Arroz_Integral_0_5kg_FRONTAL.png',
  variations: [{
    id: 168,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Gato_Filhote_Sabor_Frango_e_Arroz_Integral_0_5kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/gato-filhote-frango-e-arroz-integral/'
  }],
  em: 4.3,
  type: 'Low Grain',
  test: function test(data) {
    return rules.puppy.test(data);
  }
}, // Adult
{
  product: 'GUABI NATURAL ADULT CAT',
  image: 'GN_Cereais_Integrais_Gato_Adulto_Sabor_Frango_e_Arroz_Integral_7_5kg_FRONTAL.png',
  variations: [{
    id: 176,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Gato_Adulto_Sabor_Frango_e_Arroz_Integral_7_5kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/gato-adulto-frango-e-arroz-integral/'
  }, {
    id: 171,
    product: 'SALMON AND BARLEY',
    image: 'GN_Cereais_Integrais_Gato_Adulto_Sabor_Salmao_e_Cevada_7_5kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/gato-adulto-salmao-e-cevada/'
  }],
  em: 4.15,
  type: 'Low Grain',
  test: function test(data) {
    return rules.adult.test(data);
  }
}, // Grain Free
{
  product: 'GUABI NATURAL GRAIN FREE ADULT CAT NEUTERED',
  image: 'Guabi_Natural_Grain_Free_Gato_Adulto_Castrado_Salmao_e_Lentilha_7_5kg_FRONTAL.png',
  variations: [{
    id: -1,
    product: 'SALMON AND LENTIL',
    image: 'Guabi_Natural_Grain_Free_Gato_Adulto_Castrado_Salmao_e_Lentilha_7_5kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/grain-free-gato-adulto-castrado-salmao-e-lentilha/'
  }],
  em: 4.1,
  type: 'Grain Free',
  test: function test(data) {
    return data.specialNeeds === 'neutered' && rules.adult.test(data);
  }
}]; // SACHETS
// ----------------------------------------------------------------------------------------------------------

var sachets = [{
  product: 'GUABI NATURAL SACHET ADULT CAT NEUTERED',
  image: 'GN_Cereais_Integrais_Sache_Gato_Adulto_Castrado_Frango_Salmao_Cereais_Integrais_e_Vegetais_85g_FRONTAL.png',
  variations: [{
    id: -1,
    product: 'CHICKEN, SALMON, WHOLE CEREALS AND VEGETABLES',
    image: 'GN_Cereais_Integrais_Sache_Gato_Adulto_Castrado_Frango_Salmao_Cereais_Integrais_e_Vegetais_85g_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/sache-gato-adulto-castrado-frango-salmao-cereais-integrais-e-vegetais/'
  }, {
    id: -1,
    product: 'CHICKEN, WHOLE CEREALS AND VEGETABLES',
    image: 'GN_Cereais_Integrais_Sache_Gato_Adulto_Castrado_Frango_Cereais_Integrais_e_Vegetais_85g_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/sache-gato-adulto-castrado-frango-cereais-integrais-e-vegetais/'
  }],
  em: 0.2,
  grams: 85,
  type: 'Low Grain',
  test: function test(data) {
    return (data.specialNeeds === 'neutered' || data.specialNeeds === '') && (rules.adult.test(data) || rules.senior.test(data) || rules.puppy.test(data));
  }
}, {
  product: 'GUABI NATURAL GRAIN FREE SACHET ADULT CAT NEUTERED',
  image: 'GN_Grain_Free_Sache_Gato_Adulto_Castrado_Frango_Salmao_e_Vegetais_85g_FRONTAL.png',
  variations: [{
    id: -1,
    product: 'CHICKEN, SALMON AND VEGETABLES',
    image: 'GN_Grain_Free_Sache_Gato_Adulto_Castrado_Frango_Salmao_e_Vegetais_85g_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/grain-free-sache-gato-adulto-castrado-frango-salmao-e-vegetais/'
  }],
  em: 0.2,
  grams: 85,
  type: 'Grain Free',
  test: function test(data) {
    return (data.specialNeeds === 'neutered' || data.specialNeeds === '') && (rules.adult.test(data) || rules.senior.test(data) || rules.puppy.test(data));
  }
}]; // ----------------------------------------------------------------------------------------------------------

function getRule(data) {
  //data.size = getWeigthSize(data.weight);
  var rule;

  for (var i = 0; i < rulesTestPriority.length; i++) {
    var curRule = rulesTestPriority[i];

    if (rules[curRule] && rules[curRule].test && rules[curRule].test(data)) {
      rule = rules[curRule];
      console.log('Calculating as ' + curRule);
      break;
    }
  }

  return rule;
}

function getResult(data) {
  var rule = getRule(data);
  if (!rule) throw 'Calculation rule not defined.';
  var result = {
    type: 'cat',
    nem: rule.getNEM(data),
    lowGrainDryFood: dryFoods.find(function (f) {
      return f.type === 'Low Grain' && f.test(data);
    }),
    grainFreeDryFood: dryFoods.find(function (f) {
      return f.type === 'Grain Free' && f.test(data);
    }),
    lowGrainSachet: sachets.find(function (s) {
      return s.type === 'Low Grain' && s.test(data);
    }),
    grainFreeSachet: sachets.find(function (s) {
      return s.type === 'Grain Free' && s.test(data);
    }),
    diets: {}
  }; // ************
  // delete(result.lowGrainSachet);
  // delete(result.grainFreeSachet);
  // ************

  var sachePercent = rule.name == 'puppy' ? 0.05 : 0.1;
  var nemSachet = rule.getNEMSachet ? rule.getNEMSachet(data) : result.nem * sachePercent; // Low Grain

  if (result.nem > 0 && result.lowGrainDryFood && result.lowGrainDryFood.em > 0) {
    // Dry
    result.diets.lowGrainDry = {
      grams: result.nem / result.lowGrainDryFood.em
    }; // Wet

    var sachetFood = result.lowGrainSachet && result.lowGrainSachet.em > 0 ? result.lowGrainSachet : result.grainFreeSachet;

    if (sachetFood && sachetFood.em > 0) {
      result.diets.lowGrainMix = {
        sachets: Math.max(1, Math.round(nemSachet / sachetFood.em / sachetFood.grams))
      }; //let dryNem = result.nem - (result.diets.lowGrainMix.sachets * sachetFood.em * sachetFood.grams);

      var dryNem = result.nem * (1 - sachePercent);
      result.diets.lowGrainMix.grams = dryNem / result.lowGrainDryFood.em; //result.diets.lowGrainMix.grams = dryNem / 4.1;
      // Mix 2

      if (sachetFood == result.lowGrainSachet && result.grainFreeSachet && result.grainFreeSachet.em > 0) {
        var sachetFood2 = result.grainFreeSachet;
        result.diets.lowGrainMix2 = {
          sachets: Math.max(1, Math.round(nemSachet / sachetFood2.em / sachetFood2.grams))
        };
        var dryNem2 = result.nem * (1 - sachePercent);
        result.diets.lowGrainMix2.grams = dryNem2 / result.lowGrainDryFood.em;
      }
    }
  } // Grain Free


  if (result.nem > 0 && result.grainFreeDryFood && result.grainFreeDryFood.em > 0) {
    // Dry
    result.diets.grainFreeDry = {
      grams: result.nem / result.grainFreeDryFood.em
    }; // Wet

    var _sachetFood = result.grainFreeSachet && result.grainFreeSachet.em > 0 ? result.grainFreeSachet : result.lowGrainSachet;

    if (_sachetFood && _sachetFood.em > 0) {
      result.diets.grainFreeMix = {
        sachets: Math.max(1, Math.round(nemSachet / _sachetFood.em / _sachetFood.grams))
      }; //let dryNem = result.nem - (result.diets.grainFreeMix.sachets * sachetFood.em * sachetFood.grams);

      var _dryNem = result.nem * (1 - sachePercent);

      result.diets.grainFreeMix.grams = _dryNem / result.grainFreeDryFood.em; //result.diets.grainFreeMix.grams = dryNem / 4.1;
      // Mix 2

      if (_sachetFood == result.grainFreeSachet && result.lowGrainSachet && result.lowGrainSachet.em > 0) {
        var _sachetFood2 = result.lowGrainSachet;
        result.diets.grainFreeMix2 = {
          sachets: Math.max(1, Math.round(nemSachet / _sachetFood2.em / _sachetFood2.grams))
        };

        var _dryNem2 = result.nem * (1 - sachePercent);

        result.diets.grainFreeMix2.grams = _dryNem2 / result.grainFreeDryFood.em;
      }
    }
  }

  return result;
}

module.exports = {
  brand: 'GN',
  name: 'gato',
  getRule: getRule,
  getResult: getResult,
  races: races,
  //rules: rules,
  dryFoods: dryFoods,
  sachets: sachets
};

},{}],4:[function(require,module,exports){
"use strict";

/* Data: {
    age,
    weight,
    *race,
    specialNeeds (light, sensitive, pregnant, lactating)
    ?activity (low, medium, high)
    ?bodyConditionScore (5 - Ideal weight, 6 - Overweight, 7 - Overweight),
    ?pregnancyPeriod (1 - Less or equal 4 weeks, 2 - 4 weeks or more),
    ?numberOfPuppies (1 - 20)
    ?lactationWeek (week 1 - 7)
}
*/
//let outputRange = {min: 0, max: 2000}
var getWeigthSize = function getWeigthSize(weigth) {
  return weigth < 6 ? 'mini' : weigth < 11 ? 'small' : weigth < 26 ? 'medium' : weigth < 45 ? 'big' : 'giant';
};

var getWeigthSizeLight = function getWeigthSizeLight(weigth) {
  return weigth < 6 ? 'mini' : weigth <= 12 ? 'small' : weigth <= 27.5 ? 'medium' : weigth < 45 ? 'big' : 'giant';
};

var getWeigthSizeObese = function getWeigthSizeObese(weigth) {
  return weigth < 6 ? 'mini' : weigth <= 15 ? 'small' : weigth <= 37.5 ? 'medium' : weigth < 45 ? 'big' : 'giant';
}; // RACES
// ----------------------------------------------------------------------------------------------------------

/*
let races = [
    { "name": "Akita Inu" },
    { "name": "Beagle" },
    { "name": "Beagle Harrier" },
    { "name": "Bobtail" },
    { "name": "Boiadeiro de Berna" },
    { "name": "Boxer" },
    { "name": "Braco Alemão" },
    { "name": "Braco Francês" },
    { "name": "Bull Terrier Inglês" },
    { "name": "Bulldog Americano" },
    { "name": "Bulldog Inglês" },
    { "name": "Cairn Terrier" },
    { "name": "Cane Corso" },
    { "name": "Caniche" },
    { "name": "Cão d’Água Espanhol" },
    { "name": "Cão de Crista Chinês" },
    { "name": "Cão Lobo Checoslovaco" },
    { "name": "Cavalier King Charles Spaniel" },
    { "name": "Chihuahua" },
    { "name": "Chow-Chow" },
    { "name": "Cocker Americano" },
    { "name": "Cocker Spaniel Inglês" },
    { "name": "Collie" },
    { "name": "Dálmata" },
    { "name": "Doberman" },
    { "name": "Dogue Alemão" },
    { "name": "Dogue de Bordéus" },
    { "name": "Epagneul Bretão" },
    { "name": "Fila Brasileiro" },
    { "name": "Fox Terrier" },
    { "name": "Galgo Afegão" },
    { "name": "Golden Retriever" },
    { "name": "Husky Siberiano" },
    { "name": "Ibizan Hound" },
    { "name": "Jack Russel Terrier" },
    { "name": "Lhasa Apso" },
    { "name": "Mastiff" },
    { "name": "Mastim dos Pirenéus" },
    { "name": "Mastim Espanhol" },
    { "name": "Mastim Napolitano" },
    { "name": "Norfolk Terrier" },
    { "name": "Papillon" },
    { "name": "Pastor Alemão" },
    { "name": "Pastor de Beauce" },
    { "name": "Pequeno Basset Griffon" },
    { "name": "Pequeno Brabançon" },
    { "name": "Pequeno Cão Leão" },
    { "name": "Pequinês" },
    { "name": "Perdigueiro Português" },
    { "name": "Pinscher Anão" },
    { "name": "Pitbull" },
    { "name": "Rottweiler" },
    { "name": "Samoiedo" },
    { "name": "São Bernardo" },
    { "name": "Schnauzer" },
    { "name": "Setter Inglês" },
    { "name": "Setter Irlandês" },
    { "name": "Shar Pei" },
    { "name": "Shih Tzu" },
    { "name": "Spaniel Japonês" },
    { "name": "Spitz Alemão" },
    { "name": "Staffordshire Bull Terrier" },
    { "name": "Teckel" },
    { "name": "Terranova" },
    { "name": "Terrier Brasileiro" },
    { "name": "Vizsla" },
    { "name": "Waimaraner" },
    { "name": "West Highland White Terrier" },
    { "name": "Yorkshire Terrier" },
    { "name": "Sem raça definida (SRD)" }
];
*/


var races = [{
  "name": "Afghan Greyhound"
}, {
  "name": "Aidi"
}, {
  "name": "Airedale Terrier"
}, {
  "name": "Akita"
}, {
  "name": "Alaska Malamute"
}, {
  "name": "Alpine Basset"
}, {
  "name": "American Bulldog"
}, {
  "name": "American Bully"
}, {
  "name": "American Foxhound"
}, {
  "name": "American Pit Bull Terrier"
}, {
  "name": "American Spaniel Cocker"
}, {
  "name": "American Staffordshire Terrier"
}, {
  "name": "American Water Dog"
}, {
  "name": "Argentine Doggo"
}, {
  "name": "Ariege Braco"
}, {
  "name": "Artois Dog"
}, {
  "name": "Australian Cattle Dog"
}, {
  "name": "Australian Shepherd"
}, {
  "name": "Australian Terrier"
}, {
  "name": "Austrian Black Hound and Fire"
}, {
  "name": "Auvergne's Braco"
}, {
  "name": "Azawakh"
}, {
  "name": "Barbet"
}, {
  "name": "Basenji"
}, {
  "name": "Basset Hound"
}, {
  "name": "Beagle Harrier"
}, {
  "name": "Beagle"
}, {
  "name": "Bearded Collie"
}, {
  "name": "Bedlington Terrier"
}, {
  "name": "Belgian Groenendael Shepherd"
}, {
  "name": "Belgian Malinois Shepherd"
}, {
  "name": "Belgium Griffon"
}, {
  "name": "Bergamasco Shepherd"
}, {
  "name": "Bergamo Shepherd"
}, {
  "name": "Bernese Mountain Dog"
}, {
  "name": "Bestiar Dog"
}, {
  "name": "Bichon Bolognese"
}, {
  "name": "Bichon Frize"
}, {
  "name": "Biewer"
}, {
  "name": "Billy"
}, {
  "name": "Black and Brown Coonhound"
}, {
  "name": "Black and Brown Miniature Terrier"
}, {
  "name": "Black Coonhound and Fire"
}, {
  "name": "Bloodhound"
}, {
  "name": "Blue Basset of Gascony"
}, {
  "name": "Blue Hiller"
}, {
  "name": "Border Collie"
}, {
  "name": "Border Terrier"
}, {
  "name": "Borzoi"
}, {
  "name": "Boston Terrier"
}, {
  "name": "Bourbon Braco"
}, {
  "name": "Boxer"
}, {
  "name": "Brazilian Fila"
}, {
  "name": "Brazilian Terrier"
}, {
  "name": "british spaniel"
}, {
  "name": "Brittany Fawn Griffin"
}, {
  "name": "Broholmer"
}, {
  "name": "Brussels Griffon"
}, {
  "name": "Bull Terrier"
}, {
  "name": "Bullmastiff"
}, {
  "name": "Cairn Terrier"
}, {
  "name": "Canaã Dog"
}, {
  "name": "Canadian Eskimo (Esquimau)"
}, {
  "name": "Canary Doggo"
}, {
  "name": "Cane Corso"
}, {
  "name": "Catalan Shepherd"
}, {
  "name": "Cavalier King Charles Spaniel"
}, {
  "name": "Chesapeake Bay Retriever"
}, {
  "name": "Chihuahua"
}, {
  "name": "Chinese Crested Dog"
}, {
  "name": "Chow Chow"
}, {
  "name": "Collie Long Hair"
}, {
  "name": "Collie Short Hair"
}, {
  "name": "Continental Dwarf Spaniel"
}, {
  "name": "Coton de Tulear"
}, {
  "name": "Coton Tulear"
}, {
  "name": "Country Bulldog"
}, {
  "name": "Cowboy"
}, {
  "name": "Croatian Shepherd"
}, {
  "name": "Curly Haired Retriever"
}, {
  "name": "Czech Terrier"
}, {
  "name": "Dachshund"
}, {
  "name": "Dalmatian"
}, {
  "name": "Dandie Dinmont Terrier"
}, {
  "name": "Dingo (Haliki, Warrigal, Noggum, Boolomo)"
}, {
  "name": "Doberman"
}, {
  "name": "Dogue de Bordeaux"
}, {
  "name": "Drenthe Partridge Spaniel"
}, {
  "name": "Drever"
}, {
  "name": "Dutch Shepherd"
}, {
  "name": "Dwarf Eskimo of America"
}, {
  "name": "English Bulldog"
}, {
  "name": "English Foxhound"
}, {
  "name": "English Seter"
}, {
  "name": "English Spaniel Cocker"
}, {
  "name": "English Spaniel Springer"
}, {
  "name": "English Springer"
}, {
  "name": "Engllish Toy Terrier"
}, {
  "name": "Eurasian Dog"
}, {
  "name": "Field Spaniel"
}, {
  "name": "Finnish Hound"
}, {
  "name": "Finnish Shepherd of Lapland"
}, {
  "name": "Finnish Spitz"
}, {
  "name": "Flat Coated Retriever"
}, {
  "name": "Flat Fur Retriever"
}, {
  "name": "Fox Terrier"
}, {
  "name": "French Bulldog"
}, {
  "name": "French Spaniel"
}, {
  "name": "French"
}, {
  "name": "Frision Water Dog"
}, {
  "name": "Gascogne-type French Braco"
}, {
  "name": "Gascon Saintongeois"
}, {
  "name": "German Braco"
}, {
  "name": "German Hound"
}, {
  "name": "German Pointer"
}, {
  "name": "German Shepherd"
}, {
  "name": "German Spitz/Pomeranian Lulu"
}, {
  "name": "Giant Schnauzer"
}, {
  "name": "Golden Retriever"
}, {
  "name": "Gordon Setter"
}, {
  "name": "Great Dane of Tibet"
}, {
  "name": "Great Dane"
}, {
  "name": "Great Swiss Cattleman"
}, {
  "name": "Greyhound"
}, {
  "name": "Greyster (Norway)"
}, {
  "name": "Griffon Nivernais"
}, {
  "name": "Halden's Hound"
}, {
  "name": "Hamilton Hound"
}, {
  "name": "Hamiltonstovare"
}, {
  "name": "Hanover"
}, {
  "name": "Havanese Bichon"
}, {
  "name": "Hokkaido"
}, {
  "name": "Hovawart"
}, {
  "name": "Hungarian Greyhound"
}, {
  "name": "Hygen Hound"
}, {
  "name": "Iceland Dog"
}, {
  "name": "Irish Glen of Imaal Terrier"
}, {
  "name": "Irish Greyhound"
}, {
  "name": "Irish Seter"
}, {
  "name": "Irish Soft Coated Wheaten Terrier"
}, {
  "name": "Irish Terrier"
}, {
  "name": "Irish Water Dog"
}, {
  "name": "Irish Wolfhound"
}, {
  "name": "Istrian Hound"
}, {
  "name": "Italian Braco"
}, {
  "name": "Italian Greyhound"
}, {
  "name": "Italian Hound"
}, {
  "name": "Italian Spitz"
}, {
  "name": "Italian Vulpine"
}, {
  "name": "Jack Russell Terrier"
}, {
  "name": "Jagdterrier"
}, {
  "name": "Japanese Spaniel"
}, {
  "name": "Japanese Spitz"
}, {
  "name": "Japanese Terrier"
}, {
  "name": "Kai"
}, {
  "name": "Kelpie"
}, {
  "name": "Kerry Beagle (Pocadan)"
}, {
  "name": "Kerry Blue Terrier"
}, {
  "name": "King Charles Spaniel"
}, {
  "name": "Kishu"
}, {
  "name": "Komondor"
}, {
  "name": "Korean Jindo Dog"
}, {
  "name": "Krast Hillside Shepherd"
}, {
  "name": "Kromfohrlander"
}, {
  "name": "Kuvasz"
}, {
  "name": "Kyi Apso (Bearded Tibetan Great Dane)"
}, {
  "name": "Kyi Leo"
}, {
  "name": "Labradoodle (Australia)"
}, {
  "name": "Labrador Retriever"
}, {
  "name": "Lagotto Romagnolo"
}, {
  "name": "Laica"
}, {
  "name": "Laika"
}, {
  "name": "Lakeland Terrier"
}, {
  "name": "Lancashire Heeler (Ormskirk Terrier)"
}, {
  "name": "Landseer"
}, {
  "name": "Leonberger"
}, {
  "name": "Lhasa Apso"
}, {
  "name": "Little Italian Greyhound"
}, {
  "name": "Little Lion Dog"
}, {
  "name": "Lucas Terrier (Great Britain)"
}, {
  "name": "Lurcher (Great Britain)"
}, {
  "name": "Majestic Tree Hound (United States)"
}, {
  "name": "Majorcan Dogue"
}, {
  "name": "Maltese"
}, {
  "name": "Manchester Terrier"
}, {
  "name": "Maremmano Abruzes Shepherd"
}, {
  "name": "Mastiff"
}, {
  "name": "Medium Schnauzer"
}, {
  "name": "Meridional Russia Shepherd"
}, {
  "name": "Mexican Naked"
}, {
  "name": "Miniature Schnauzer"
}, {
  "name": "Mountain Cur (United States)"
}, {
  "name": "Mudi"
}, {
  "name": "Munster Spaniel"
}, {
  "name": "Napolitan Mastim"
}, {
  "name": "Napolitan Mastino"
}, {
  "name": "New Land"
}, {
  "name": "New Scotia Retriever"
}, {
  "name": "New Zeland Huntaway"
}, {
  "name": "Norboten Spitz"
}, {
  "name": "Norfolk Terrier"
}, {
  "name": "Norman Artesian Basset"
}, {
  "name": "Norwegian Buhund"
}, {
  "name": "Norwegian Dog"
}, {
  "name": "Norwegian Elkhound (Black)"
}, {
  "name": "Norwegian Hound"
}, {
  "name": "Norwich Terrier"
}, {
  "name": "Old English Brazilian Bulldogge"
}, {
  "name": "Old English Bulldog"
}, {
  "name": "Old English Sheepdog"
}, {
  "name": "Papillon"
}, {
  "name": "Patterdale Terrier (Black Fell-Terrier)"
}, {
  "name": "Pekingese"
}, {
  "name": "Peruvian Naked"
}, {
  "name": "Picardy Blue Spaniel"
}, {
  "name": "Picardy Spaniel"
}, {
  "name": "Pinscher"
}, {
  "name": "Plain Polish Shepherd"
}, {
  "name": "Plott Hound"
}, {
  "name": "Plummer Terrier"
}, {
  "name": "Pointer"
}, {
  "name": "Poitevin"
}, {
  "name": "Polish Hound"
}, {
  "name": "Polonese Greyhound"
}, {
  "name": "Pont-Audemer Spaniel"
}, {
  "name": "Poodle"
}, {
  "name": "Porcelana"
}, {
  "name": "Portuguese Podengo"
}, {
  "name": "Portuguese Water Dog"
}, {
  "name": "Posavatz Hound"
}, {
  "name": "Prazky Krysavick"
}, {
  "name": "Pudelpointer"
}, {
  "name": "Pug"
}, {
  "name": "Puli"
}, {
  "name": "Pumi"
}, {
  "name": "Pyrenean Mastiff"
}, {
  "name": "Pyrenees-type French Braco"
}, {
  "name": "Rafeiro do Alentejo"
}, {
  "name": "Rampur Hen (India)"
}, {
  "name": "Rastreador Brasileiro"
}, {
  "name": "Redbone Coonhound"
}, {
  "name": "Redtick Coonhound"
}, {
  "name": "Rhodesian Ridgeback (Rhodesian Dorsal Crested Dog)"
}, {
  "name": "Rottweiler"
}, {
  "name": "Russian Black Terrier"
}, {
  "name": "Saint Germain Braco"
}, {
  "name": "Saint-Usuge Spaniel"
}, {
  "name": "Saluki"
}, {
  "name": "Samoieda"
}, {
  "name": "Sanshu"
}, {
  "name": "Sarplaninac"
}, {
  "name": "Schapendoes"
}, {
  "name": "Schiller's Hound"
}, {
  "name": "Schipperke"
}, {
  "name": "Scotch Greyhound"
}, {
  "name": "Scottish Terrier"
}, {
  "name": "Sealyham Terrier"
}, {
  "name": "Seter Gordon"
}, {
  "name": "Shar Pei"
}, {
  "name": "Shepherd of Anatolia"
}, {
  "name": "Shepherd of Beauce"
}, {
  "name": "Shepherd of Brie"
}, {
  "name": "Shepherd of Central Asia"
}, {
  "name": "Shepherd of Maremma and the Abruzzi"
}, {
  "name": "Shepherd of North America"
}, {
  "name": "Shepherd of Picardy"
}, {
  "name": "Shepherd of Pireneus"
}, {
  "name": "Shepherd of Russia"
}, {
  "name": "Shepherd of Shetland"
}, {
  "name": "Shiba"
}, {
  "name": "Shih Tzu"
}, {
  "name": "Shiloh Shepherd"
}, {
  "name": "Siberian Husky"
}, {
  "name": "Silky Terrier"
}, {
  "name": "Skye Terrier"
}, {
  "name": "Sloughi"
}, {
  "name": "Slougi"
}, {
  "name": "Slovak Cuvac"
}, {
  "name": "slovak hound"
}, {
  "name": "Slovak Tchouvatch"
}, {
  "name": "Smaland Hound"
}, {
  "name": "Smaland stovare"
}, {
  "name": "Small Dutch Dog"
}, {
  "name": "Small Dutch Water Hound"
}, {
  "name": "Smooth Haired Retriever"
}, {
  "name": "Smoushond"
}, {
  "name": "Spanish Greyhound"
}, {
  "name": "Spanish Hound"
}, {
  "name": "Spanish Mastim"
}, {
  "name": "Spanish Water Dog"
}, {
  "name": "Spinone Italiano"
}, {
  "name": "Spitz of the Visigoths"
}, {
  "name": "St Bernard"
}, {
  "name": "Stabyhoun"
}, {
  "name": "Staffordshire Bull Terrier"
}, {
  "name": "Standard Schnauzer"
}, {
  "name": "Star Mountain Dog"
}, {
  "name": "Sussex Spaniel"
}, {
  "name": "Swiss Hound"
}, {
  "name": "Swiss Hounds"
}, {
  "name": "Thai Dorsal Crested Dog"
}, {
  "name": "Tibetan Spaniel"
}, {
  "name": "Tibetan Terrier"
}, {
  "name": "Tosa"
}, {
  "name": "Treeing Walker Coonhoud"
}, {
  "name": "Trigg-Hound"
}, {
  "name": "Tyrolean Hound"
}, {
  "name": "Vendee Griffin"
}, {
  "name": "Viszla"
}, {
  "name": "Wavy Haired Retriever"
}, {
  "name": "Weimaraner"
}, {
  "name": "Welch Terrier"
}, {
  "name": "Welsh Corgi"
}, {
  "name": "Welsh Springer"
}, {
  "name": "Welsh Terrier"
}, {
  "name": "West Highland White Terrier"
}, {
  "name": "Westphalian German Basset"
}, {
  "name": "Whippet"
}, {
  "name": "White Shepherd"
}, {
  "name": "White Swiss Shepherd"
}, {
  "name": "Wirehaired Slovak Pointing Gryphon"
}, {
  "name": "Woolly fur Griffon"
}, {
  "name": "York Chocolat"
}, {
  "name": "Yorkshire Terrier"
}, {
  "name": "Yugoslavian Tricolor Hounds"
}]; // RULES
// ----------------------------------------------------------------------------------------------------------

var rules = {};
var rulesTestPriority = ['sensitive', 'light', 'pregnant', 'lactating', 'obese', 'weightloss', 'puppy', 'senior', 'adult'];
/* Special Needs - Sensitive */

rules.sensitive = {
  name: 'sensitive',
  data: {
    scoreData: {
      3: {
        multiplier: 130
      },
      5: {
        activityMultiplier: {
          low: 95,
          medium: 110,
          high: 130
        }
      }
    },
    exp: 0.75
  },
  requiredFields: ['weight', 'age', 'specialNeeds', 'activity', 'bodyConditionScore'],
  test: function test(data) {
    return data.specialNeeds === 'sensitive' && data.weight > 0 && data.age > 0 && !rules.puppy.test(data);
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.'; // Overweight

    var scoreData = rules.sensitive.data.scoreData[data.bodyConditionScore];
    if (!scoreData) throw 'Inform a valid body condition.';

    if (data.bodyConditionScore != '5') {
      return Math.pow(data.weight, rules.sensitive.data.exp) * scoreData.multiplier;
    }

    if (!scoreData.activityMultiplier[data.activity]) throw 'Inform a valid level of physical activity.';
    return Math.pow(data.weight, rules.sensitive.data.exp) * scoreData.activityMultiplier[data.activity];
  }
};
/* Special Needs - Light */

rules.light = {
  name: 'light',
  data: {
    scoreData: {
      5: {
        activityMultiplier: {
          low: 95,
          medium: 110,
          high: 130
        }
      },
      6: {
        multiplier: 85
      }
    },
    exp: 0.75
  },
  requiredFields: ['weight', 'age', 'specialNeeds', 'activity', 'bodyConditionScore'],
  test: function test(data) {
    return data.specialNeeds === 'light' && data.weight > 0 && data.age > 0 && !rules.puppy.test(data);
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.'; // Overweight

    var scoreData = rules.light.data.scoreData[data.bodyConditionScore];
    if (!scoreData) throw 'Inform a valid body condition.';

    if (data.bodyConditionScore != '5') {
      return Math.pow(data.weight, rules.light.data.exp) * scoreData.multiplier;
    }

    if (!scoreData.activityMultiplier[data.activity]) throw 'Inform a valid level of physical activity.';
    return Math.pow(data.weight, rules.light.data.exp) * scoreData.activityMultiplier[data.activity];
  },
  getRecommendedWeightLosses: function getRecommendedWeightLosses(data) {
    if (data.bodyConditionScore != 6) return;
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    return {
      min: data.weight * 10,
      // weight * 0,01 * 1000
      max: data.weight * 20 // weight * 0,02 * 1000

    };
  }
};
/* Special Needs - Pregnant */

rules.pregnant = {
  name: 'pregnant',
  data: {
    pregnancyPeriod: {
      1: {
        multiplier: 132,
        addMultiplier: 0
      },
      2: {
        multiplier: 132,
        addMultiplier: 26
      }
    },
    exp: 0.75
  },
  requiredFields: ['weight', 'age', 'specialNeeds', 'pregnancyPeriod'],
  test: function test(data) {
    return data.specialNeeds === 'pregnant' && data.weight > 0 && data.age > 0 && (rules.adult.test(data) || rules.senior.test(data));
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var periodData = rules.pregnant.data.pregnancyPeriod[data.pregnancyPeriod];
    if (!periodData) throw 'Inform a valid pregnancy period.';
    return Math.pow(data.weight, rules.pregnant.data.exp) * periodData.multiplier + data.weight * periodData.addMultiplier;
  }
};
/* Special Needs - Lactating */

rules.lactating = {
  name: 'lactating',
  data: {
    lactationWeekMultiplier: {
      1: 0.75,
      2: 0.95,
      3: 1.1,
      4: 1.2
    },
    multiplier: 145,
    exp: 0.75
  },
  requiredFields: ['weight', 'age', 'specialNeeds', 'lactationWeek', 'numberOfPuppies'],
  test: function test(data) {
    return data.specialNeeds === 'lactating' && data.weight > 0 && data.age > 0 && rules.adult.test(data);
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var calcData = rules.lactating.data;
    if (!calcData.lactationWeekMultiplier[data.lactationWeek]) throw 'Inform a valid lactation week.';
    var n = Math.min(4, data.numberOfPuppies);
    var m = Math.max(data.numberOfPuppies - n, 0);
    var c = 24 * n + 12 * m;
    return calcData.multiplier * Math.pow(data.weight, calcData.exp) + data.weight * c * calcData.lactationWeekMultiplier[data.lactationWeek];
  }
};
/* Special Needs - obese - Weight maintenance */

rules.obese = {
  name: 'obese',
  data: {
    multiplier: 68,
    exp: 0.75
  },
  requiredFields: ['weight', 'age', 'specialNeeds'
  /*, 'bodyConditionScore'*/
  ],
  test: function test(data) {
    return data.specialNeeds === 'obese' && data.weight > 0 && data.age > 0 && (rules.adult.test(data) || rules.senior.test(data));
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var calcData = rules.obese.data;
    return Math.pow(data.weight, calcData.exp) * calcData.multiplier;
  }
};
/* Special Needs - obese - Weight loss - Prescrição somente */

rules.weightloss = {
  name: 'weightloss',
  data: {
    multiplier: 61,
    exp: 0.75
  },
  requiredFields: ['weight', 'age', 'specialNeeds', 'bodyConditionScore'],
  test: function test(data) {
    return data.specialNeeds === 'weightloss' && data.weight > 0 && data.age > 0 && (rules.adult.test(data) || rules.senior.test(data));
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var calcData = rules.weightloss.data;
    return Math.pow(data.weight, calcData.exp) * calcData.multiplier;
  },
  getRecommendedWeightLosses: function getRecommendedWeightLosses(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    return {
      min: data.weight * 10,
      // weight * 0,01 * 1000
      max: data.weight * 20 // weight * 0,02 * 1000

    };
  }
};
/* Puppy */

rules.puppy = {
  name: 'puppy',
  data: {
    getMaxMonths: function getMaxMonths(weight) {
      if (!(weight > 0)) return;
      var size = getWeigthSize(weight);

      switch (size) {
        case 'mini':
          return 10;

        case 'small':
        case 'medium':
          return 12;

        case 'big':
          return 15;

        case 'giant':
          return 18;
      }
    },
    const: 254,
    multiplier: 135,
    exp: 0.75
  },
  requiredFields: ['weight', 'actualWeight', 'age'],
  test: function test(data) {
    var maxMonths = rules.puppy.data.getMaxMonths(data.weight);
    console.log(data, maxMonths, getWeigthSize(data.weight));
    return data.weight > 0 && data.age > 0 && data.age <= maxMonths;
  },
  getNEM: function getNEM(data) {
    if (!rules.puppy.test(data)) throw 'Inform a valid puppy data.';
    if (!(data.actualWeight > 0)) throw 'Inform a valid actual weight.';
    if (parseInt(data.weight) < parseInt(data.actualWeight)) throw 'Actual weight cannot be bigger than adult weight.';
    return (rules.puppy.data.const - rules.puppy.data.multiplier * (data.actualWeight / data.weight)) * Math.pow(data.actualWeight, rules.puppy.data.exp);
  }
};
/* Senior */

rules.senior = {
  name: 'senior',
  data: {
    sizeMinAges: {
      'mini': 7 * 12,
      'small': 7 * 12,
      'medium': 7 * 12,
      'big': 5 * 12,
      'giant': 5 * 12
    },
    scoreData: {
      3: {
        multiplier: 130
      },
      5: {
        activityMultiplier: {
          low: 95,
          medium: 110,
          high: 130
        }
      }
    },
    exp: 0.75
  },
  requiredFields: ['weight', 'age', 'activity', 'bodyConditionScore'],
  test: function test(data) {
    return rules.senior.data.sizeMinAges[data.size] && data.weight > 0 && data.age > 0 && data.age >= rules.senior.data.sizeMinAges[data.size];
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var scoreData = rules.senior.data.scoreData[data.bodyConditionScore];
    if (!scoreData) throw 'Inform a valid body condition score.';
    if (data.bodyConditionScore == 5 && !scoreData.activityMultiplier[data.activity]) throw 'Inform a valid level of physical activity.';
    if (data.bodyConditionScore == 5) return Math.pow(data.weight, rules.senior.data.exp) * scoreData.activityMultiplier[data.activity];
    return Math.pow(data.weight, rules.senior.data.exp) * scoreData.multiplier;
  }
};
/* Adult */

rules.adult = {
  name: 'adult',
  data: {
    scoreData: {
      3: {
        multiplier: 130
      },
      5: {
        activityMultiplier: {
          low: 95,
          medium: 110,
          high: 130
        }
      }
    },
    exp: 0.75
  },
  requiredFields: ['weight', 'age', 'activity', 'bodyConditionScore'],
  test: function test(data) {
    return !rules.puppy.test(data) && data.age > 0 && data.weight > 0 && !rules.senior.test(data);
  },
  getNEM: function getNEM(data) {
    if (!(data.weight > 0)) throw 'Inform a valid weight.';
    var scoreData = rules.adult.data.scoreData[data.bodyConditionScore];
    if (!scoreData) throw 'Inform a valid body condition score.'; // if (!scoreData.activityMultiplier[data.activity]) throw 'Inform a valid level of physical activity.';
    //return Math.pow(data.weight, rules.adult.data.exp) * scoreData.activityMultiplier[data.activity] * scoreData.weight;

    if (data.bodyConditionScore == 5 && !scoreData.activityMultiplier[data.activity]) throw 'Inform a valid level of physical activity.';
    if (data.bodyConditionScore == 5) return Math.pow(data.weight, rules.adult.data.exp) * scoreData.activityMultiplier[data.activity];
    return Math.pow(data.weight, rules.adult.data.exp) * scoreData.multiplier;
  }
}; // DRY FOODS
// ----------------------------------------------------------------------------------------------------------

var dryFoods = [// light
{
  product: 'GUABI NATURAL ADULT DOG LIGHT MEDIUM AND BIG SIZE',
  image: 'GN_Cereais_Integrais_Cao_Adulto_Light_Medio_e_Grande_Sabor_Peru_e_Aveia_15kg_FRONTAL.png',
  variations: [{
    id: 370,
    product: 'TURKEY AND OATS',
    image: 'GN_Cereais_Integrais_Cao_Adulto_Light_Medio_e_Grande_Sabor_Peru_e_Aveia_15kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-light-porte-medio-e-grande-peru-e-aveia/'
  }],
  em: 3.6,
  type: 'Low Grain',
  test: function test(data) {
    return data.specialNeeds === 'light' && ['medium', 'big', 'giant'].indexOf(getWeigthSizeLight(data.weight)) >= 0 && (rules.adult.test(data) || rules.senior.test(data));
  }
}, {
  product: 'GUABI NATURAL ADULT DOG LIGHT MINI AND SMALL SIZE',
  image: 'GN_Cereais_Integrais_Cao_Adulto_Light_Mini_e_Pequeno_Sabor_Peru_e_Aveia_12kg_FRONTAL.png',
  variations: [{
    id: 373,
    product: 'TURKEY AND OATS',
    image: 'GN_Cereais_Integrais_Cao_Adulto_Light_Mini_e_Pequeno_Sabor_Peru_e_Aveia_12kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-light-porte-mini-e-pequeno-peru-e-aveia/'
  }],
  em: 3.7,
  type: 'Low Grain',
  test: function test(data) {
    return data.specialNeeds === 'light' && ['mini', 'small'].indexOf(getWeigthSizeLight(data.weight)) >= 0 && (rules.adult.test(data) || rules.senior.test(data));
  }
}, // Sensitive
{
  product: 'GUABI NATURAL ADULT DOG SENSITIVE MINI, SMALL AND MEDIUM',
  image: 'GN_Cereais_Integrais_Cao_Adulto_Sensitive_Mini_Pequeno_e_Medio_Sabor_Salmao_e_Aveia_12kg_FRONTAL.png',
  variations: [{
    id: 376,
    product: 'SALMON AND OATS',
    image: 'GN_Cereais_Integrais_Cao_Adulto_Sensitive_Mini_Pequeno_e_Medio_Sabor_Salmao_e_Aveia_12kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-sensitive-porte-mini-pequeno-e-medio-salmao-e-aveia/'
  }],
  em: 4.05,
  type: 'Low Grain',
  test: function test(data) {
    return data.specialNeeds === 'sensitive' && ['mini', 'small', 'medium'].indexOf(data.size) >= 0 && (rules.adult.test(data) || rules.senior.test(data));
  }
}, // Pregnant
{
  product: 'GUABI NATURAL PUPPY DOG MINI AND SMALL SIZE',
  image: 'GN_Cereais_Integrais_Cao_Filhote_Mini_e_Pequeno_Sabor_Frango_e_Arroz_Integral_1kg_FRONTAL.png',
  variations: [{
    id: 91,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Filhote_Mini_e_Pequeno_Sabor_Frango_e_Arroz_Integral_1kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-filhote-porte-mini-e-pequeno-frango-e-arroz-integral/'
  }],
  em: 4.35,
  type: 'Low Grain',
  message: 'Guabi Natural puppy dog can be offered to pregnant or lactating dogs',
  test: function test(data) {
    return data.specialNeeds === 'pregnant' && ['mini', 'small'].indexOf(data.size) >= 0 && rules.adult.test(data);
  }
}, {
  product: 'GUABI NATURAL PUPPY DOG MEDIUM',
  image: 'GN_Cereais_Integrais_Cao_Filhote_Medio_Sabor_Frango_e_Arroz_Integral_20kg_FRONTAL.png',
  variations: [{
    id: 117,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Filhote_Medio_Sabor_Frango_e_Arroz_Integral_20kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-filhote-porte-medio-frango-arroz-integral/'
  }],
  em: 4.25,
  type: 'Low Grain',
  message: 'Guabi Natural puppy dog can be offered to pregnant or lactating dogs',
  test: function test(data) {
    return data.specialNeeds === 'pregnant' && ['medium'].indexOf(data.size) >= 0 && rules.adult.test(data);
  }
}, {
  product: 'GUABI NATURAL PUPPY DOG BIG AND GIANT SIZE',
  image: 'GN_Cereais_Integrais_Cao_Filhote_Grande_e_Gigante_Sabor_Frango_e_Arroz_Integral_15kg_FRONTAL.png',
  variations: [{
    id: 122,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Filhote_Grande_e_Gigante_Sabor_Frango_e_Arroz_Integral_15kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-filhote-porte-grande-e-gigante-frango-e-arroz-integral/'
  }],
  em: 4.15,
  type: 'Low Grain',
  message: 'Guabi Natural puppy dog can be offered to pregnant or lactating dogs',
  test: function test(data) {
    return data.specialNeeds === 'pregnant' && ['big', 'giant'].indexOf(data.size) >= 0 && rules.adult.test(data);
  }
}, // Lactating
{
  product: 'GUABI NATURAL PUPPY DOG MINI AND SMALL SIZE',
  image: 'GN_Cereais_Integrais_Cao_Filhote_Mini_e_Pequeno_Sabor_Frango_e_Arroz_Integral_1kg_FRONTAL.png',
  variations: [{
    id: 91,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Filhote_Mini_e_Pequeno_Sabor_Frango_e_Arroz_Integral_1kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-filhote-porte-mini-e-pequeno-frango-e-arroz-integral/'
  }],
  em: 4.35,
  type: 'Low Grain',
  message: 'Guabi Natural puppy dog can be offered to pregnant or lactating dogs',
  test: function test(data) {
    return data.specialNeeds === 'lactating' && ['mini', 'small'].indexOf(data.size) >= 0 && rules.adult.test(data);
  }
}, {
  product: 'GUABI NATURAL PUPPY DOG MEDIUM',
  image: 'GN_Cereais_Integrais_Cao_Filhote_Medio_Sabor_Frango_e_Arroz_Integral_20kg_FRONTAL.png',
  variations: [{
    id: 117,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Filhote_Medio_Sabor_Frango_e_Arroz_Integral_20kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-filhote-porte-medio-frango-arroz-integral/'
  }],
  em: 4.25,
  type: 'Low Grain',
  message: 'Guabi Natural puppy dog can be offered to pregnant or lactating dogs',
  test: function test(data) {
    return data.specialNeeds === 'lactating' && ['medium'].indexOf(data.size) >= 0 && rules.adult.test(data);
  }
}, {
  product: 'GUABI NATURAL PUPPY DOG BIG AND GIANT SIZE',
  image: 'GN_Cereais_Integrais_Cao_Filhote_Grande_e_Gigante_Sabor_Frango_e_Arroz_Integral_15kg_FRONTAL.png',
  variations: [{
    id: 122,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Filhote_Grande_e_Gigante_Sabor_Frango_e_Arroz_Integral_15kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-filhote-porte-grande-e-gigante-frango-e-arroz-integral/'
  }],
  em: 4.15,
  type: 'Low Grain',
  message: 'Guabi Natural puppy dog can be offered to pregnant or lactating dogs',
  test: function test(data) {
    return data.specialNeeds === 'lactating' && ['big', 'giant'].indexOf(data.size) >= 0 && rules.adult.test(data);
  }
}, // Puppy
{
  product: 'GUABI NATURAL PUPPY DOG BIG AND GIANT SIZE',
  image: 'GN_Cereais_Integrais_Cao_Filhote_Grande_e_Gigante_Sabor_Frango_e_Arroz_Integral_15kg_FRONTAL.png',
  variations: [{
    id: 122,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Filhote_Grande_e_Gigante_Sabor_Frango_e_Arroz_Integral_15kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-filhote-porte-grande-e-gigante-frango-e-arroz-integral/'
  }],
  em: 4.15,
  type: 'Low Grain',
  test: function test(data) {
    return ['big', 'giant'].indexOf(data.size) >= 0 && rules.puppy.test(data);
  }
}, {
  product: 'GUABI NATURAL PUPPY DOG MEDIUM',
  image: 'GN_Cereais_Integrais_Cao_Filhote_Medio_Sabor_Frango_e_Arroz_Integral_20kg_FRONTAL.png',
  variations: [{
    id: 117,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Filhote_Medio_Sabor_Frango_e_Arroz_Integral_20kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-filhote-porte-medio-frango-arroz-integral/'
  }],
  em: 4.25,
  type: 'Low Grain',
  test: function test(data) {
    return ['medium'].indexOf(data.size) >= 0 && rules.puppy.test(data);
  }
}, {
  product: 'GUABI NATURAL PUPPY DOG MINI AND SMALL SIZE',
  image: 'GN_Cereais_Integrais_Cao_Filhote_Mini_e_Pequeno_Sabor_Frango_e_Arroz_Integral_1kg_FRONTAL.png',
  variations: [{
    id: 91,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Filhote_Mini_e_Pequeno_Sabor_Frango_e_Arroz_Integral_1kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-filhote-porte-mini-e-pequeno-frango-e-arroz-integral/'
  }],
  em: 4.35,
  type: 'Low Grain',
  test: function test(data) {
    return ['mini', 'small'].indexOf(data.size) >= 0 && rules.puppy.test(data);
  }
}, // Senior
{
  product: 'GUABI NATURAL SENIOR DOG MEDIUM AND BIG SIZE',
  image: 'GN_Cereais_Integrais_Cao_Senior_Medio_e_Grande_Sabor_Frango_e_Arroz_Integral_15kg_FRONTAL.png',
  variations: [{
    id: 380,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Senior_Medio_e_Grande_Sabor_Frango_e_Arroz_Integral_15kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-senior-porte-medio-e-grande-frango-e-arroz-integral/'
  }],
  em: 3.85,
  type: 'Low Grain',
  test: function test(data) {
    return ['medium', 'big', 'giant'].indexOf(data.size) >= 0 && rules.senior.test(data) && data.specialNeeds != 'obese' && data.specialNeeds != 'weightloss';
  }
}, {
  product: 'GUABI NATURAL SENIOR DOG MINI AND SMALL SIZE',
  image: 'GN_Cereais_Integrais_Cao_Senior_Mini_e_Pequeno_Sabor_Frango_e_Arroz_Integral_12kg_FRONTAL.png',
  variations: [{
    id: 384,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Senior_Mini_e_Pequeno_Sabor_Frango_e_Arroz_Integral_12kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-senior-porte-mini-e-pequeno-frango-e-arroz-integral/'
  }],
  em: 3.95,
  type: 'Low Grain',
  test: function test(data) {
    return ['mini', 'small'].indexOf(data.size) >= 0 && rules.senior.test(data) && data.specialNeeds != 'obese' && data.specialNeeds != 'weightloss';
  }
}, // Adult
{
  product: 'GUABI NATURAL ADULT DOG BIG AND GIANT SIZE',
  image: 'GN_Cereais_Integrais_Cao_Adulto_Grande_e_Gigante_Sabor_Frango_e_Arroz_Integral_15kg_FRONTAL.png',
  variations: [{
    id: 151,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Adulto_Grande_e_Gigante_Sabor_Frango_e_Arroz_Integral_15kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-porte-grande-e-gigante-frango-e-arroz-integral/'
  }, {
    id: 148,
    product: 'SALMON AND BARLEY',
    image: 'GN_Cereais_Integrais_Cao_Adulto_Grande_e_Gigante_Sabor_Salmao_e_Cevada_15kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-porte-grande-e-gigante-salmao-e-cevada/'
  }, {
    id: 154,
    product: 'LAMB AND OATS',
    image: 'GN_Cereais_Integrais_Cao_Adulto_Grande_e_Gigante_Sabor_Cordeiro_e_Aveia_15kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-porte-grande-e-gigante-cordeiro-e-aveia/'
  }],
  em: 4.05,
  type: 'Low Grain',
  test: function test(data) {
    return ['big', 'giant'].indexOf(data.size) >= 0 && rules.adult.test(data) && data.specialNeeds != 'obese' && data.specialNeeds != 'weightloss';
  }
}, {
  product: 'GUABI NATURAL ADULT DOG MEDIUM',
  image: 'GN_Cereais_Integrais_Cao_Adulto_Medio_Sabor_Frango_e_Arroz_Integral_15kg_FRONTAL.png',
  variations: [{
    id: 142,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Adulto_Medio_Sabor_Frango_e_Arroz_Integral_15kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-porte-medio-frango-e-arroz-integral/'
  }, {
    id: 137,
    product: 'SALMON AND BARLEY',
    image: 'GN_Cereais_Integrais_Cao_Adulto_Medio_Sabor_Salmao_e_Cevada_15kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-porte-medio-salmao-e-cevada/'
  }, {
    id: 145,
    product: 'LAMB AND OATS',
    image: 'GN_Cereais_Integrais_Cao_Adulto_Medio_Sabor_Cordeiro_e_Aveia_15kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-porte-medio-cordeiro-e-aveia/'
  }],
  em: 4.15,
  type: 'Low Grain',
  test: function test(data) {
    return ['medium'].indexOf(data.size) >= 0 && rules.adult.test(data) && data.specialNeeds != 'obese' && data.specialNeeds != 'weightloss';
  }
}, {
  product: 'GUABI NATURAL ADULT DOG MINI AND SMALL SIZE',
  image: 'GN_Cereais_Integrais_Cao_Adulto_Mini_e_Pequeno_Sabor_Frango_e_Arroz_Integral_10_1kg_FRONTAL.png',
  variations: [{
    id: 131,
    product: 'CHICKEN AND BROWN RICE',
    image: 'GN_Cereais_Integrais_Cao_Adulto_Mini_e_Pequeno_Sabor_Frango_e_Arroz_Integral_10_1kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-porte-mini-e-pequeno-frango-e-arroz-integral/'
  }, {
    id: 127,
    product: 'SALMON AND BARLEY',
    image: 'GN_Cereais_Integrais_Cao_Adulto_Mini_e_Pequeno_Sabor_Salmao_e_Cevada_10_1kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-porte-mini-e-pequeno-salmao-e-cevada/'
  }, {
    id: 134,
    product: 'LAMB AND OATS',
    image: 'GN_Cereais_Integrais_Cao_Adulto_Mini_e_Pequeno_Sabor_Cordeiro_e_Aveia_10_1kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-porte-mini-e-pequeno-cordeiro-e-aveia/'
  }],
  em: 4.25,
  type: 'Low Grain',
  test: function test(data) {
    return ['mini', 'small'].indexOf(data.size) >= 0 && rules.adult.test(data) && data.specialNeeds != 'obese' && data.specialNeeds != 'weightloss';
  }
}, // Grain Free
{
  product: 'GUABI NATURAL GRAIN FREE ADULT DOG MINI AND SMALL SIZE',
  image: 'GN_Grain_Free_Cao_Adulto_Mini_e_Pequeno_Sabor_Frango_e_Lentilha_10_1kg_FRONTAL.png',
  variations: [{
    id: -1,
    product: 'CHICKEN AND LENTIL',
    image: 'GN_Grain_Free_Cao_Adulto_Mini_e_Pequeno_Sabor_Frango_e_Lentilha_10_1kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/grain-free-cao-adulto-mini-e-pequeno-frango-e-lentilha/'
  }],
  em: 4.5,
  type: 'Grain Free',
  test: function test(data) {
    return ['mini', 'small'].indexOf(data.size) >= 0 && data.specialNeeds == '' && rules.adult.test(data);
  }
}, {
  product: 'GUABI NATURAL GRAIN FREE ADULT DOG MEDIUM',
  image: 'GN_Grain_Free_Cao_Adulto_Medio_Sabor_Frango_e_Lentilha_12kg_FRONTAL.png',
  variations: [{
    id: -1,
    product: 'CHICKEN AND LENTIL',
    image: 'GN_Grain_Free_Cao_Adulto_Medio_Sabor_Frango_e_Lentilha_12kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/grain-free-cao-adulto-porte-medio-frango-e-lentilha/'
  }],
  em: 4.4,
  type: 'Grain Free',
  test: function test(data) {
    return ['medium'].indexOf(data.size) >= 0 && data.specialNeeds == '' && rules.adult.test(data);
  }
}, // Obese
{
  product: 'GUABI NATURAL ADULT DOG OBESE MINI AND SMALL SIZE',
  image: 'GN_Cao_Adulto_Obeso_Mini_e_Pequeno_Sabor_Frango_e_Arroz_Integral_10_1kg_FRONTAL.png',
  variations: [{
    id: -1,
    product: '',
    image: 'GN_Cao_Adulto_Obeso_Mini_e_Pequeno_Sabor_Frango_e_Arroz_Integral_10_1kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-mini-e-pequeno-obeso/'
  }],
  em: 3.1,
  type: 'Low Grain',
  test: function test(data) {
    return ['mini', 'small'].indexOf(getWeigthSizeObese(data.weight)) >= 0 && (data.specialNeeds == 'obese' || data.specialNeeds == 'weightloss') && (rules.adult.test(data) || rules.senior.test(data));
  }
}, {
  product: 'GUABI NATURAL ADULT DOG OBESE MEDIUM AND BIG SIZE',
  image: 'GN_Cao_Adulto_Obeso_Medio_e_Grande_Sabor_Frango_e_Arroz_Integral_10_1kg_FRONTAL.png',
  variations: [{
    id: -1,
    product: '',
    image: 'GN_Cao_Adulto_Obeso_Medio_e_Grande_Sabor_Frango_e_Arroz_Integral_10_1kg_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/cao-adulto-obeso/'
  }],
  em: 3.1,
  type: 'Low Grain',
  test: function test(data) {
    return ['medium', 'big', 'giant'].indexOf(getWeigthSizeObese(data.weight)) >= 0 && (data.specialNeeds == 'obese' || data.specialNeeds == 'weightloss') && (rules.adult.test(data) || rules.senior.test(data));
  }
}]; // SACHETS
// ----------------------------------------------------------------------------------------------------------

var sachets = [{
  product: 'GUABI NATURAL SACHET ADULT DOG',
  image: 'GN_Cereais_Integrais_Sache_Cao_Adulto_Frango_Cereais_Integrais_e_Vegetais_100g_FRONTAL.png',
  variations: [{
    id: -1,
    product: 'CHICKEN, WHOLE CEREALS AND VEGETABLES',
    image: 'GN_Cereais_Integrais_Sache_Cao_Adulto_Frango_Cereais_Integrais_e_Vegetais_100g_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/sache-cao-adulto-frango-cereais-integrais-e-vegetais/'
  }, {
    id: -1,
    product: 'CHICKEN, SALMON, WHOLE CEREALS AND VEGETABLES',
    image: 'GN_Cereais_Integrais_Sache_Cao_Adulto_Frango_Salmao_Cereais_Integrais_e_Vegetais_100g_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/sache-cao-adulto-frango-salmao-cereais-integrais-e-vegetais/'
  }],
  em: 0.2,
  grams: 100,
  type: 'Low Grain',
  test: function test(data) {
    return (data.specialNeeds == '' || data.specialNeeds == 'light' || data.specialNeeds == 'obese' || data.specialNeeds == 'weightloss') && (rules.adult.test(data) || rules.senior.test(data) || rules.puppy.test(data));
  }
}, {
  product: 'GUABI NATURAL GRAIN FREE SACHET ADULT DOG',
  image: 'GN_Grain_Free_Sache_Cao_Adulto_Frango_Salmao_e_Vegetais_100g_FRONTAL.png',
  variations: [{
    id: -1,
    product: 'CHICKEN, SALMON AND VEGETABLES',
    image: 'GN_Grain_Free_Sache_Cao_Adulto_Frango_Salmao_e_Vegetais_100g_FRONTAL.png',
    link: 'https://guabinatural.com.br/produtos/grain-free-sache-cao-adulto-frango-salmao-e-vegetais/'
  }],
  em: 0.2,
  grams: 100,
  type: 'Grain Free',
  test: function test(data) {
    return (data.specialNeeds == '' || data.specialNeeds == 'light' || data.specialNeeds == 'obese' || data.specialNeeds == 'weightloss') && (rules.adult.test(data) || rules.senior.test(data) || rules.puppy.test(data));
  }
}]; // ----------------------------------------------------------------------------------------------------------

function getRule(data) {
  data.size = getWeigthSize(data.weight);
  var rule;

  for (var i = 0; i < rulesTestPriority.length; i++) {
    var curRule = rulesTestPriority[i];

    if (rules[curRule] && rules[curRule].test && rules[curRule].test(data)) {
      rule = rules[curRule];
      console.log('Calculating as ' + curRule);
      break;
    }
  }

  return rule;
}

function getResult(data) {
  var rule = getRule(data);
  if (!rule) throw 'Calculation rule not registered.';
  var result = {
    type: 'dog',
    rule: rule.name,
    nem: rule.getNEM(data),
    lowGrainDryFood: dryFoods.find(function (f) {
      return f.type === 'Low Grain' && f.test(data);
    }),
    grainFreeDryFood: dryFoods.find(function (f) {
      return f.type === 'Grain Free' && f.test(data);
    }),
    lowGrainSachet: sachets.find(function (s) {
      return s.type === 'Low Grain' && s.test(data);
    }),
    grainFreeSachet: sachets.find(function (s) {
      return s.type === 'Grain Free' && s.test(data);
    }),
    diets: {}
  };
  var sachePercent = rule.name == 'light' && data.bodyConditionScore == '6' || rule.name == 'obese' || rule.name == 'weightloss' || rule.name == 'puppy' ? 0.05 : 0.1;
  var nemSachet = rule.getNEMSachet ? rule.getNEMSachet(data) : result.nem * sachePercent; // console.log(result.nem, sachePercent)
  // Low Grain

  if (result.nem > 0 && result.lowGrainDryFood && result.lowGrainDryFood.em > 0) {
    //let lowGrainDryFoodEM = data && data.specialNeeds == 'pregnant' ? 4.35 : result.lowGrainDryFood.em;
    var lowGrainDryFoodEM = result.lowGrainDryFood.em; // Dry

    result.diets.lowGrainDry = {
      grams: result.nem / lowGrainDryFoodEM
    }; // Wet

    var sachetFood = result.lowGrainSachet && result.lowGrainSachet.em > 0 ? result.lowGrainSachet : result.grainFreeSachet;

    if (sachetFood && sachetFood.em > 0) {
      result.diets.lowGrainMix = {
        sachets: Math.max(1, Math.round(nemSachet / sachetFood.em / sachetFood.grams))
      }; //let dryNem = result.nem - (result.diets.lowGrainMix.sachets * sachetFood.em * sachetFood.grams);

      var dryNem = result.nem * (1 - sachePercent);
      result.diets.lowGrainMix.grams = dryNem / lowGrainDryFoodEM; //result.diets.lowGrainMix.grams = dryNem / 4.5;
      // Mix 2

      if (sachetFood == result.lowGrainSachet && result.grainFreeSachet && result.grainFreeSachet.em > 0) {
        var sachetFood2 = result.grainFreeSachet;
        result.diets.lowGrainMix2 = {
          sachets: Math.max(1, Math.round(nemSachet / sachetFood2.em / sachetFood2.grams))
        };
        var dryNem2 = result.nem * (1 - sachePercent);
        result.diets.lowGrainMix2.grams = dryNem2 / lowGrainDryFoodEM;
      }
    }
  } // Grain Free


  if (result.nem > 0 && result.grainFreeDryFood && result.grainFreeDryFood.em > 0) {
    var grainFreeDryFoodEM = data && data.specialNeeds == 'pregnant' ? 4.35 : result.grainFreeDryFood.em; // Dry

    result.diets.grainFreeDry = {
      grams: result.nem / grainFreeDryFoodEM
    }; // Wet

    var _sachetFood = result.grainFreeSachet && result.grainFreeSachet.em > 0 ? result.grainFreeSachet : result.lowGrainSachet;

    if (_sachetFood && _sachetFood.em > 0) {
      result.diets.grainFreeMix = {
        sachets: Math.max(1, Math.round(nemSachet / _sachetFood.em / _sachetFood.grams))
      }; //let dryNem = result.nem - (result.diets.grainFreeMix.sachets * sachetFood.em * sachetFood.grams);

      var _dryNem = result.nem * (1 - sachePercent);

      result.diets.grainFreeMix.grams = _dryNem / grainFreeDryFoodEM; //result.diets.grainFreeMix.grams = dryNem / 4.5;
      // Mix 2

      if (_sachetFood == result.grainFreeSachet && result.lowGrainSachet && result.lowGrainSachet.em > 0) {
        var _sachetFood2 = result.lowGrainSachet;
        result.diets.grainFreeMix2 = {
          sachets: Math.max(1, Math.round(nemSachet / _sachetFood2.em / _sachetFood2.grams))
        };

        var _dryNem2 = result.nem * (1 - sachePercent);

        result.diets.grainFreeMix2.grams = _dryNem2 / grainFreeDryFoodEM;
      }
    }
  }

  if (rule.getRecommendedWeightLosses) result.recommendedWeightLosses = rule.getRecommendedWeightLosses(data);
  return result;
}

module.exports = {
  brand: 'GN',
  name: 'cão',
  getRule: getRule,
  getResult: getResult,
  races: races,
  //rules: rules,
  dryFoods: dryFoods,
  sachets: sachets
};

},{}],5:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

;

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : (0, _typeof2.default)(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.Calc = factory();
})(void 0, function () {
  var Calc = window.Calc || {};
  var CalcObj = {};
  Calc['GN'] = CalcObj;
  CalcObj.Calcs = {
    dog: require('./_calc-dog'),
    cat: require('./_calc-cat')
  };
  /**
   * Pet type names
   */

  CalcObj.PetType = {};

  for (var i = 0; i < Object.keys(CalcObj.Calcs).length; i++) {
    var key = Object.keys(CalcObj.Calcs)[i];
    CalcObj.PetType[key] = CalcObj.Calcs[key].name;
  }
  /**
   * Get results from pet information
   *
   * @param {string} petType
   * @param {object} petData
   *
   * @returns {object}
   */


  CalcObj.CalculateResults = function (petType, petData) {
    if (!CalcObj.PetType[petType] || !CalcObj.Calcs[petType]) throw 'The type of pet informed is unknown';
    if (!petData || Object.keys(petData).length == 0) throw 'The pet data is empty';
    return CalcObj.Calcs[petType].calc(petData);
  };

  return Calc;
});

},{"./_calc-cat":3,"./_calc-dog":4,"@babel/runtime/helpers/interopRequireDefault":1,"@babel/runtime/helpers/typeof":2}]},{},[5])(5)
});
